import http from '@/helpers/http'
import Vue from '@/installCompositionApi'
import { mountComponentTag } from '@/mounter'

import Validate from '../forms/directives/validate'
import QuizModule from './QuizModule'

Vue.directive('validate', Validate)

http.create({
  axiosConfig: {
    baseURL: '/',
  },
})

mountComponentTag('quiz', QuizModule)
